export const capitalizeFirst = s => {
  if (!s) return ''

  if (typeof s !== 'string') return ''

  return s.charAt(0).toUpperCase() + s.slice(1)
}
